// extracted by mini-css-extract-plugin
module.exports = {"scrollbar-shift":"adjustForScrollbar_scrollbar-shift__lnhKh"};